import * as React from "react";
import { AppRoutesType } from "@workers/rest-api";
import { hc as hcReal } from "hono/client";
// @ts-expect-error ...
import { hc as hcDistClient } from "hono/dist/client";

import { env } from "~/env";
import { useSessionContext } from "~/lib/supabase";

const hc = hcDistClient as typeof hcReal;
export type HonoClient = ReturnType<typeof hc<AppRoutesType>>["api"]["v1"];

export type GlobalHonoClient = ReturnType<typeof hc<AppRoutesType>>;
const GlobalHonoCtx = React.createContext<GlobalHonoClient | null>(null);

export function GlobalHonoProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { session } = useSessionContext();

  const honoClient = React.useMemo(
    () =>
      hc<AppRoutesType>(env.EXPO_PUBLIC_REST_API_BASE_URL, {
        headers: { authorization: `Bearer ${session?.access_token}` },
      }),
    [session?.access_token],
  );

  return (
    <GlobalHonoCtx.Provider value={honoClient}>
      {children}
    </GlobalHonoCtx.Provider>
  );
}

export function useHonoClient() {
  const client = React.useContext(GlobalHonoCtx);
  if (client == null)
    throw "useHonoClient must be children of GlobalHonoProvider";

  // dont remove this useMemo, it causes infinite re-renders for some reason
  return React.useMemo(() => ({ hc: client.api.v1 }), [client]);
}

export function useGlobalHonoClient() {
  const client = React.useContext(GlobalHonoCtx);
  if (client == null)
    throw "useGlobalHonoClient must be children of GlobalHonoProvider";

  return React.useMemo(() => ({ globalHc: client }), [client]);
}
